import {AllocatableLoad, AllocatableLoadEntity} from "../../../model/allocatable-load";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type AllocatableLoadSelectorProps = {
  // selector props here
};

export const allocatableLoadsSelector = () => createSelector(
  [getUseQueryResultData<AllocatableLoad[]>],
  (data) => {
    return selectAllocatableLoadAndTransform(data ?? []);
  }
);

export const allocatableLoadSelector = () => createSelector(
  [getUseQueryResultData<AllocatableLoad>],
  (data) => {
    return data ? transformAllocatableLoad(data) : undefined;
  }
);

export const selectAllocatableLoad = (values?: AllocatableLoad[], selector?: AllocatableLoadSelectorProps): AllocatableLoad[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    // filter selectors props here
    return filterIn;
  });
};

export const transformAllocatableLoad = (value: AllocatableLoad): AllocatableLoadEntity => {
  return AllocatableLoadEntity.from(value)
}

export const selectAllocatableLoadAndTransform = (values?: AllocatableLoad[], selector?: AllocatableLoadSelectorProps): AllocatableLoadEntity[] => {
  const selected = selectAllocatableLoad(values, selector);
  return selected.map(transformAllocatableLoad);
};
